/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Promised Prepayment Selectors
 *
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.10.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import { IPromisedPaymentState } from './promisedPaymentReducer';

export const selectPromisedPaymentState = (state: IRootReducer): IPromisedPaymentState => state.promisedPayment;

export const makeSelectPromisedPaymentLoading = ():
    OutputSelector<IRootReducer, boolean, (state: IPromisedPaymentState) => boolean> =>
    createSelector(selectPromisedPaymentState, (state) => state.loading);

export const makeSelectPromisedPaymentAmount = ():
    OutputSelector<IRootReducer, number, (state: IPromisedPaymentState) => number> =>
    createSelector(selectPromisedPaymentState, (state) => state.amount);

export const makeSelectPromisedPaymentValidity = ():
    OutputSelector<IRootReducer, string, (state: IPromisedPaymentState) => string> =>
    createSelector(selectPromisedPaymentState, (state) => state.validity);

export const makeSelectPromisedPaymentError = ():
    OutputSelector<IRootReducer, string, (state: IPromisedPaymentState) => string> =>
    createSelector(selectPromisedPaymentState, (state) => state.error);
